/* Appends the live price to the add-to-cart label, so the button reads
   "ADD TO CART / 2,490 PKR" the way the reference does.

   The price cannot be put there in Liquid without overriding Dawn's 100KB
   main-product section, and Dawn re-renders the button on every variant
   change, so this watches the info column rather than running once. */
(function () {
  'use strict';

  function currentPrice(scope) {
    var el = scope.querySelector(
      '.price--on-sale .price-item--sale, .price__regular .price-item--regular'
    );
    return el ? el.textContent.trim() : '';
  }

  function stamp() {
    var containers = document.querySelectorAll('.product__info-container');

    for (var i = 0; i < containers.length; i += 1) {
      var info = containers[i];
      var price = currentPrice(info);
      if (!price) continue;

      var labels = info.querySelectorAll('.product-form__submit > span');
      for (var j = 0; j < labels.length; j += 1) {
        var label = labels[j];
        var tag = label.querySelector('.resemble-atc__price');

        if (!tag) {
          tag = document.createElement('span');
          tag.className = 'resemble-atc__price';
          label.appendChild(tag);
        }

        /* Only write when the text actually changed, otherwise the observer
           below would retrigger on its own mutation. */
        var next = ' / ' + price;
        if (tag.textContent !== next) tag.textContent = next;
      }
    }
  }

  function watch() {
    stamp();

    var wrapper = document.querySelector('.product__info-wrapper');
    if (!wrapper || typeof MutationObserver === 'undefined') return;

    new MutationObserver(stamp).observe(wrapper, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
